import { useEffect } from 'react';

// AUTO UPDATE (owner 30 Oct: chart changes never showed on the phone). The server sends index.html without a no-cache
// header, so a phone / Home-Screen app can keep an old page that loads old code. Every minute (and when the app comes
// back to the front) this reads index.html straight from the server (cache: 'no-store'); if it names a newer build
// than the one running, the page reloads itself - never while the user is typing in a box.
const running = () => {
  const s = Array.from(document.scripts).map(x => x.src || '').find(x => /\/static\/js\/main\.[a-z0-9]+\.js/.test(x));
  return s ? s.match(/main\.[a-z0-9]+\.js/)[0] : '';
};

export default function AutoUpdate() {
  useEffect(() => {
    const cur = running();
    if (!cur) return undefined;        // dev server: nothing to compare
    let busy = false;
    const check = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try {
        const r = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
        const m = (await r.text()).match(/main\.[a-z0-9]+\.js/);
        const typing = ['INPUT', 'TEXTAREA', 'SELECT'].includes((document.activeElement || {}).tagName);
        if (m && m[0] !== cur && !typing) window.location.reload();
      } catch (e) { /* offline: next time */ }
      busy = false;
    };
    const iv = setInterval(check, 60000);
    const vis = () => { if (!document.hidden) check(); };
    document.addEventListener('visibilitychange', vis);
    check();
    return () => { clearInterval(iv); document.removeEventListener('visibilitychange', vis); };
  }, []);
  return null;
}
